module.exports = __webpack_public_path__ + "img/1920_news_main_img1.34a02ee7.png";